import { Action } from 'redux'
import { IUser } from '../../../models/User'
import { UserAccountActions } from '../../../reducers/userAccount/actionNames'

const requestUser = (): IRequestUser => ({
  type: UserAccountActions.RequestUserData,
})
const userAccepted = (user: IUser): IUserAccepted => ({
  type: UserAccountActions.UserDataAccepted,
  user,
})

const saveUser = (user: IUser) => ({
  type: UserAccountActions.SaveUser,
  user,
})

const userRejected = (err: string): IUserRejected => ({
  errMessage: err,
  type: UserAccountActions.UserDataRejected,
})

export { requestUser, userAccepted, userRejected, saveUser }
export type IRequestUser = Action<UserAccountActions.RequestUserData>

export interface IUserAccepted
  extends Action<UserAccountActions.UserDataAccepted> {
  user: IUser
}

export interface IUserRejected
  extends Action<UserAccountActions.UserDataRejected> {
  errMessage: string
}
